import React from 'react';
import { connect } from 'react-redux';
import {
	fetchAttempt,
	sendAnswer,
	toggleFeedback,
	resetAttemptValues,
	toggleMicPermission,
	setShowThankModal,
	getLtToken,
	getProctorStatus,
	sendPauseTime
} from '../../redux/testPage/testPage.actions';
import { resetAudioBlob } from '../../redux/utilities/utils.actions';
import Loader from '../../utils/Loader';
import { similarity } from '../../utils/stringSimilarityChecker';
import { goBackTimed, goBackRegular } from '../../utils/const';

import Question from './questionType';
import QuestionFeedback from './questionFeedback';
import InsQuestion from './insQuestion';

import TestHeader from './testHeader';
import HelpModal from '../common/helpModal';
import $ from 'jquery';
import ThankYouModal from '../common/thankYouModal';
import KidsThankYouModal from '../common/KidsThankYouModal';
import Analytics from '../../utils/Analytics';
import UserTypes from '../../utils/userTypes';
import ListAnimation from '../utils/animations/list';
import './styles/assesment.styles.css';
import './styles/detailedFeedbackStyles.css';
import { tagEvent } from '../../utils/tagManager';
import { dateDiff } from '../../utils/commonFunctions';
import { activateProctor, stopProctor, checkProctorStatus } from '../../utils/supervisor';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button'
import idleTimeout from 'idle-timeout';
import { persistor } from '../../getStore'; 
import Auth from '../../utils/Auth';


const mapDispatchToProps = (dispatch) => {
	return {
		fetchAttempt: () => dispatch(fetchAttempt()),
		sendAnswer: (data) => dispatch(sendAnswer(data)),
		sendPauseTime: (data) => dispatch(sendPauseTime(data)),
		toggleFeedback: () => dispatch(toggleFeedback()),
		resetAttemptValues: () => dispatch(resetAttemptValues()),
		setShowThankModal: (val) => dispatch(setShowThankModal(val)),
		toggleMicPermission: (val) => dispatch(toggleMicPermission(val)),
		resetAudioBlob: () => dispatch(resetAudioBlob()),
		getLtToken: () => dispatch(getLtToken()),
		getProctorStatus: () => dispatch(getProctorStatus())
	};
};

const mapStateToProps = (state) => {
	const {
		leftSectionProps,
		rightSectionProps,
		isPauseTimer,
		currentAttemptId,
		feedbackChoicesOrder,
		feedbackImageChoicesOrder,
		disableSubmit,
		isFeedback,
		questions,
		submitButton,
		thanksval,
		questionNo,
		questionId,
		elementType,
		timeRemaining,
		lntToken,
		proctorResponse
	} = state.rootReducer.testPageDetails;
	const {
		elementName,
		courseId,
		coursedetails: { course_name } = {},
		previewMode,
	} = state.rootReducer.myCourse;
	const {
		productData: { product_id, product_name } = {},
	} = state.rootReducer.buyCourse;
	const { activeChildId } = state.rootReducer.parentDetails;
	const { userType, userId, enableProctor } = state.rootReducer.loginDetails;

	// const beforeunload = localStorage.getItem('beforeunload')

	return {
		leftSectionProps,
		rightSectionProps,
		isPauseTimer,
		currentAttemptId,
		feedbackChoicesOrder,
		feedbackImageChoicesOrder,
		disableSubmit,
		isFeedback,
		submitButton,
		questions,
		thanksval,
		questionNo,
		questionId,
		elementType,
		timeRemaining,
		audioBlob: state.rootReducer.utils.audioBlob,
		videoblob: state.rootReducer.utils.videoblob,
		activeChildId,
		userType,
		elementName,
		courseId,
		previewMode,
		product_id,
		course_name,
		product_name,
		userId,
		lntToken,
		enableProctor,
		proctorResponse
	};
};

class TestPage extends React.Component {

	state = { proctorStatus: '', isIdleTimeup: false };

	constructor(props) {
		super(props);
		this.state = {waitForResumeTimer: 10};
		Loader.hide();
		this.submitanswer = this.submitanswer.bind(this);
		this.submitFunction = this.submitFunction.bind(this);
		this.wordLimitForLaType = this.wordLimitForLaType.bind(this);
		this.stringSimilarityCheck = this.stringSimilarityCheck.bind(this);
		this.goBack = this.goBack.bind(this);
		this.goBackLink = this.goBackLink.bind(this);
		this.idleInterval = undefined;
		this.isTimeUp = undefined;
		this.canShowIdleReminderModel = true;
		this.submitBtnRef = React.createRef();
		this.submitBtnRef2 = React.createRef();
		this.idleInstance = {};
		this.waitForResumeInterval = undefined;
		this.waitForResumeTimer = 0
	}

	componentDidMount() {
		document.getElementById('chat-circle').style.display = 'none';
		const { fetchAttempt, getLtToken, getProctorStatus, proctorResponse } = this.props;

		fetchAttempt();
		localStorage.setItem('isPauseTimer', false);
		let CallLTProctorToken = localStorage.getItem('CallproctorToken');
		const { elementType, lntToken, enableProctor } = this.props;
		// const enableProctor = false

		if (elementType === 'S' || elementType === 'F') {
			window.history.pushState(
				{ name: 'browserBack' },
				'on browser back click',
				'/test',
			);
			window.onpopstate = (e) => {
				this.goBack(e);
			};
		}

		if(localStorage.getItem('disableTemplate') == "1") {
			$('.body-container').css('opacity', '1');
		}
		
		// if (enableProctor && !window.proctorStarted) {
		// 	let CheckLTProctorToken = localStorage.getItem('LTproctorToken');
		// 	//alert(CheckLTProctorToken)
		// 	if (!!CheckLTProctorToken) {
		// 		activateProctor(CheckLTProctorToken);
		// 	} else if(CallLTProctorToken == "") {
		// 		//alert("calling Token API"+ CheckLTProctorToken)
		// 		localStorage.setItem('CallproctorToken', '1');
		// 		getLtToken();
		// 	}
		// }

		// getProctorStatus()

		// const proctorCheck = setInterval(() => {
		// 	const status = proctorResponse ? proctorResponse.status : 'Data not found'

		// 	if(status === 'paused') {
		// 		clearInterval(proctorCheck)
		// 	}
		// 	getProctorStatus()
		// }, 10000);

		// console.log('beforeunload '+ beforeunload +' && '+ enableProctor)
		console.log('window.proctorStarted ', window.proctorStarted)
		if (enableProctor) {
			let CheckLTProctorToken = localStorage.getItem('LTproctorToken')
			if (!!CheckLTProctorToken) {
				let getProcSta = checkProctorStatus()
				console.log('checkProctorStatus ', getProcSta)
				if(!getProcSta) {
					activateProctor(CheckLTProctorToken)
				}
			} else if(CallLTProctorToken == "") {
				localStorage.setItem('CallproctorToken', '1')
				// getLtToken()
			}
		}

		this.idleInstance = idleTimeout(
			() => {
			  	// Callback
				this.idleInstance.pause();
				this.onIdle()
			},
			{
				element: document,
				timeout: 1000 * 60 * 3,
				loop: true
			}
		);

		// this.startIdleInterval()
		this.startIsTimeUpInterval()

		const { isFeedback } = this.props;
		if (isFeedback) {
			if (this.submitBtnRef.current) {
				this.submitBtnRef.current.disabled = false
			}
		} else {
			if (this.submitBtnRef2.current) {
				this.submitBtnRef2.current.disabled = false
			}
		}
	}

	componentDidUpdate(prevProps, prevState) {
		const { elementType, lntToken, enableProctor } = this.props;
		const { resetAudioBlob, audioBlob, questionId, proctorResponse } = this.props;
		const status = proctorResponse ? proctorResponse.status : 'Data not found'
		const lsStatus = sessionStorage.getItem('proctorRecordStatusTime') ? Number(sessionStorage.getItem('proctorRecordStatusTime')) : 0
		const lsStatusDifference = lsStatus !== 0 ? (Number(new Date()) - lsStatus) : (Number(new Date()) - lsStatus) > 60000 ? 31000 : (Number(new Date()) - lsStatus)

		if(status === 'paused' && prevProps.proctorResponse.status !== 'paused' && lsStatusDifference > 30000 && lsStatusDifference < 35000) {
			sessionStorage.setItem('proctorRecordStatusTime', Number(new Date()))
			this.setState((prevState) => {
				return {
						...prevState,
					proctorStatus: status,
				};
			});
		}

		if (prevProps.questionId !== questionId) {
			if (!!audioBlob && Object.keys(audioBlob).length > 0) {
				resetAudioBlob();
			}
		}
		localStorage.setItem('CallproctorToken', '1');

		// this.startIdleInterval()
		this.canShowIdleReminderModel = true;

		const { isFeedback } = this.props;
		if (isFeedback) {
			if (this.submitBtnRef.current) {
				this.submitBtnRef.current.disabled = false
			}
		} else {
			if (this.submitBtnRef2.current) {
				this.submitBtnRef2.current.disabled = false
			}
		}

		// const CheckLTProctorToken = localStorage.getItem('LTproctorToken')
		// if (enableProctor) {
		// 	if (!!CheckLTProctorToken) {
		// 		activateProctor(CheckLTProctorToken)
		// 	}
		// }
	}

	componentWillUnmount() {
		//this.props.resetAttemptValues();
		// clearInterval(this.idleInterval)
		clearInterval(this.isTimeUp)
		window.removeEventListener('popstate', this.goBack);
	}

	previewExit = () => {
		const {
			userId,
			elementName,
			courseId,
			course_name,
			product_id,
			product_name,
			previewMode,
		} = this.props;

		if (previewMode) {
			tagEvent({
				event: 'end_course_preview',
				user_id: userId,
				duration: Math.abs(
					dateDiff('seconds', localStorage.getItem('previewWebisodeStart')),
				),
				activity_name: elementName,
				course_id: courseId,
				grant_name: course_name,
				product_id,
				product_name,
				platform: 'web',
			});
			localStorage.removeItem('previewWebisodeStart');
		}
	};

	goBackLink() {
		const { activeChildId, userType } = this.props;
		let goBackLink =
			userType === UserTypes.Parent
				? `${window.location.origin}/child/dashboard/${activeChildId}`
				: userType === UserTypes.Junior
				? `${window.location.origin}/junior/dashboard`
				: `${window.location.origin}/mycourse`;
		window.history.pushState(null, null, goBackLink);
	}

	goBack(e) {
		const { elementType } = this.props;
		// const [min, sec] = !!timeRemaining ? toHHMMSS(timeRemaining).split(':') : ['00', '00'];
		if (!!e.state) {
			let confirmationMsg =
				elementType === 'S' || elementType === 'F' ? goBackTimed : goBackRegular;

			if (window.confirm(confirmationMsg)) {
				this.goBackLink();
				this.previewExit();
				window.history.go();
			} else {
				window.history.pushState(null, null, window.location.pathname);
				e.preventDefault();
			}
		}
	}

	displayError(userAnswer, errorDivId) {
		let el = document.getElementById(errorDivId);
		if (!!el) {
			if (userAnswer === '') {
				el.style.display = 'block';
				Loader.hide();
				return true;
			} else {
				el.style.display = 'none';
			}
		}
	}

	submitFunction() {
		this.canShowIdleReminderModel = false;
		const {
			submitButton,
			questionId,
			questionNo,
			setShowThankModal,
		} = this.props;
		if (submitButton.toLowerCase() === 'next') {
			Analytics('closeFeedback', {
				screen: 'testPage',
				action: 'buttonClick',
				info: { question_id: questionId, question_no: questionNo },
				user_id: localStorage.getItem('login_user_id'),
			});
			const { thanksval, toggleFeedback } = this.props;
			if (Object.entries(thanksval).length > 0) {
				setShowThankModal(true);
				// stopProctor();
				// console.log('proctor 5 stop');
			} else {
				toggleFeedback();
			}
		} else this.submitanswer();

		document.body.scrollTop = document.documentElement.scrollTop = 0;
	}

	stringSimilarityCheck(userAnswer) {
		let question =
			!!document.getElementsByClassName('question-img-desc') &&
			document.getElementsByClassName('question-img-desc').length > 0
				? document.getElementsByClassName('question-img-desc')[0].innerText
				: '';

		if (similarity(question, userAnswer) > 50) {
			let el = document.getElementById('errorWrite');
			el.innerHTML = `Your answer is too similar to the question. Please try rewording your answer.`;
			el.style.display = 'block';
			Loader.hide();
			return true;
		}
	}

	wordLimitForLaType() {
		const {
			rightSectionProps: { qlevel },
		} = this.props;
		let el = document.getElementById('errorWrite');
		var index = -1;
		const wordLimit = {
			0: 10,
			1: 15,
			2: 20,
		};

		if (!!document.getElementById('display_count')) {
			let wordCount = parseInt(
				document.getElementById('display_count').innerHTML,
				10,
			);

			if (wordCount < 10 && qlevel >= 5 && qlevel <= 8) {
				index = 0;
			} else if (wordCount < 15 && qlevel >= 9 && qlevel <= 10) {
				index = 1;
			} else if (wordCount < 20 && qlevel >= 11 && qlevel <= 12) {
				index = 2;
			}
			if (index > -1) {
				el.innerHTML = `Your answer is too short. Please write at least '${wordLimit[index]}' words before submitting.`;
				el.style.display = 'block';
				Loader.hide();
				return true;
			}
		}
	}

	submitanswer() {
		localStorage.setItem('isPauseTimer', true);
		let {
			leftSectionProps: {
				questionId,
				qtype = null,
				vkDetails,
				cloudQuestion,
				clozeQuestion,
			},
			rightSectionProps: {
				choices,
				imageChoices,
				textLength,
				speechLength,
				resetCounter,
				resetCounters,
			},
			audioBlob,
			videoblob,
			currentAttemptId,
			questions,
			questionNo,
		} = this.props;

		Analytics('answerSubmit', {
			screen: 'testPage',
			action: 'buttonClick',
			info: { question_id: questionId, question_no: questionNo },
			user_id: localStorage.getItem('login_user_id'),
		});
		Loader.show();

		if (document.getElementById('errorTestPage')) {
			document.getElementById('errorTestPage').style.display = 'none';
		}

		localStorage.setItem('isPauseTimer', true);
		var question_id = questionId;
		var is_audio = 'no';
		var isRetry = 1;
		var audio = [];
		var video = '';
		var user_answer = '';
		var additional_user_answer = '';
		var viewAllUserAnswer = [];
		var isInvalid = false;

		//get below values from store instead
		if (resetCounters.length > 0) {
			isRetry = Math.min.apply(null, resetCounters);
			isRetry = isRetry > 0 ? 1 : 0;
		} else if (resetCounter !== undefined) {
			isRetry = resetCounter > 0 ? 1 : 0;
		}

		if (typeof questions !== 'undefined' && Object.keys(questions).length > 1) {
			let invalid = false;
			questions.forEach((que, i) => {
				if (!invalid) {
					if ($(`#ques-collapse-${i} li.active`) === null) {
						document.getElementById(`unansweredQuestion_${i}`).style.display =
							'block';
						invalid = true;

						if (
							document
								.getElementById(`question${i}`)
								?.classList.value.indexOf('collapsed') > -1
						)
							document.getElementById(`question${i}`).click();
						document.getElementById(`collapse_${i}`).scrollIntoView();
					} else {
						viewAllUserAnswer.push({
							question_id: que.question_id,
							user_answer: $(`#ques-collapse-${i} li.active input`).val(),
						});
					}
				}
			});
			if (invalid) {
				Loader.hide();
				return false;
			}
		} else if (qtype === 'INS') {
			user_answer = 'instruction';
		} else if (qtype === 'MCQ') {
			if (document.querySelector('.quiz-area-options ul li.active') !== null) {
				user_answer = document.querySelector(
					'.quiz-area-options ul li.active input',
				).value;
			} else {
				isInvalid = this.displayError(user_answer, 'errorTestPage');
			}

			localStorage.setItem('FeedbackChoicesOrder', JSON.stringify(choices));
			localStorage.setItem(
				'FeedbackImageChoicesOrder',
				JSON.stringify(imageChoices),
			);
		} else if (qtype === 'MS') {
			// MS
			if (
				document.querySelector('input[name = "MCQchoices[]"]:checked') === null
			) {
				document.getElementById('errorTestPage').style.display = 'block';
				Loader.hide();
				return false;
			} else {
				var MScheckedOptions = [];
				$("input:checkbox[name='MCQchoices[]']:checked").each(function () {
					MScheckedOptions.push($(this).val());
				});
				user_answer = MScheckedOptions.join('|');

				localStorage.setItem('FeedbackChoicesOrder', JSON.stringify(choices));
				localStorage.setItem(
					'FeedbackImageChoicesOrder',
					JSON.stringify(imageChoices),
				);
			}
		} else if (!!speechLength) {
			var audioCount = audioBlob;
			var videoCount = videoblob;
			var audio_json = {};

			if (qtype === 'Wordcloud') {
				additional_user_answer = document.getElementById('cloudResponse').value;
				isInvalid = this.displayError(additional_user_answer, 'errorWordcloudPage');
			}
			if (qtype === 'Cloze_with_passage') {
				additional_user_answer = document.getElementById('clozeResponse').value;
				isInvalid = this.displayError(additional_user_answer, 'errorClozePassage');
			}
			if (qtype === 'Cloze_with_conversation') {
				additional_user_answer = document.getElementById('clozeResponse').value;
				isInvalid = this.displayError(additional_user_answer, 'errorClozePassage');

				var audio_count = additional_user_answer.split('#');
				var audio_flag = 0;
				audio_count.forEach((val, key) => {
					let el = document.getElementById('errorTestPage_' + key);
					if (!!el) {
						el.style.display = 'none';
					}
					if (audioBlob[key] === undefined) {
						audio_flag = 1;
						if (!!el) {
							el.style.display = 'block';
						}
					}
				});
				if (audio_flag === 1) {
					Loader.hide();
					return false;
				}
				$.map(audioBlob, function (val, index) {
					audio_json[index] = val;
				});
				audio = audio_json;
				user_answer = 'audio';
				is_audio = 'yes';
			} else if (Object.entries(audioCount).length > 0) {
				if (qtype === 'VK') {
					if (
						!!vkDetails &&
						Object.entries(vkDetails).length !== Object.entries(audioCount).length
					) {
						this.showErrorPage('Some of your answers are not clear. Please retry');
						Loader.hide();
						return false;
					}
				}
				$.map(audioBlob, function (val, index) {
					audio_json[index] = val;
				});
				audio = audio_json;
				user_answer = 'audio';
				is_audio = 'yes';
				if (localStorage.getItem('karaokeStartTime') !== null) {
					localStorage.removeItem('karaokeStartTime');
					localStorage.removeItem('totalBufferTime');
				}
			} else if (!!videoCount && videoCount.length > 0) {
				video = videoblob[0];
				user_answer = 'audio';
				is_audio = 'vid';
			} else {
				let el = document.getElementById('errorTestPage');
				if (!!el) {
					el.style.display = 'block';
				}
				Loader.hide();
				return false;
			}
		} else if (!!textLength) {
			user_answer = document.getElementById('textResponse').value.trim();
			isInvalid = this.displayError(user_answer, 'errorWrite');
			isInvalid =
				!isInvalid && qtype === 'LA' ? this.wordLimitForLaType() : isInvalid;
			isInvalid =
				!isInvalid && qtype === 'LA'
					? this.stringSimilarityCheck(user_answer)
					: isInvalid;
		} else if (!!cloudQuestion) {
			user_answer = document.getElementById('cloudResponse').value;
			isInvalid = this.displayError(user_answer, 'errorTestPage');
		} else if (!!clozeQuestion) {
			// Cloze
			user_answer = document.getElementById('clozeResponse').value;
			isInvalid = this.displayError(user_answer, 'errorClozePassage');
		} else {
			isInvalid = this.displayError(user_answer, 'errorTestPage');
		}
		if (isInvalid) {
			return false;
		}

		localStorage.removeItem('videoPauseTime');
		var postData = new FormData();
		let pause_time = 0;
		if (!!$('.minuteLeft').text() && !!$('.secondsLeft').text()) {
			pause_time = $('.minuteLeft').text() * 60 + +$('.secondsLeft').text();
		}

		if (viewAllUserAnswer.length > 0) {
			postData = {
				question_id: viewAllUserAnswer[0].question_id,
				user_answer: JSON.stringify(viewAllUserAnswer),
				pause_time,
				attempt_id: currentAttemptId,
				is_audio,
				skip_domain: 0,
				is_linked_ques: 1,
			};
		} else if (is_audio === 'yes') {
			Object.keys(audio).forEach(function (key) {
				postData.append('audio[]', audio[key]);
			});
			postData.append('question_id', question_id);
			postData.append('user_answer', user_answer);
			postData.append('pause_time', pause_time);
			postData.append('attempt_id', currentAttemptId);
			postData.append('is_audio', is_audio);
			postData.append('is_retry', isRetry);
			postData.append('additional_user_answer', additional_user_answer);
			postData.append('skip_domain', 0);
		} else if (is_audio === 'vid') {
			postData = {
				video: video.video,
				question_id,
				user_answer,
				pause_time,
				attempt_id: currentAttemptId,
				is_audio,
				skip_domain: 0,
			};
		} else {
			postData = {
				question_id,
				user_answer,
				pause_time,
				attempt_id: currentAttemptId,
				is_audio,
				skip_domain: 0,
			};
		}
		Loader.show();
		this.props.sendAnswer(postData);
	}

	onIdle = () => {
		if(!this.canShowIdleReminderModel) {
			return false
		}
		if (!!$('.minuteLeft').text() && !!$('.secondsLeft').text()) {
			window.minsSecsLeft = $('.minuteLeft').text()+'~'+$('.secondsLeft').text()
			localStorage.setItem('minsSecsLeft', window.minsSecsLeft)
			window.minsSecsLeftBefore = window.minsSecsLeft
			console.log('window.minsSecsLeft ', window.minsSecsLeft)
		}

		this.setState((prevState) => {
			return {
					...prevState,
				isIdleTimeup: true,
			};
		});
		clearInterval(this.isTimeUp)
		// clearInterval(this.idleInterval)
		localStorage.setItem('minsSecsLeft', window.minsSecsLeft)
		window.stopOverallTimer = true
		this.updatePauseTime('updateNow')

		const logoutNow = () => {
			const reset = async () => {
				// stopProctor();
				let redirectUrl = localStorage.getItem('uap_callback');
				// let redirectUrl = 'https://www.google.com/';
	
				// await persistor.purge().then(() => {
				// 	return persistor.flush();
				// });
	
				// Auth.isAuthenticated = null;

				localStorage.clear();
				sessionStorage.clear();
				window.location.href = redirectUrl
			};
		
			reset();
		}
		
		this.waitForResumeInterval = setInterval(() => {
			let _waitTimer = this.state.waitForResumeTimer
			if(_waitTimer < 1) {
				clearInterval(this.waitForResumeInterval)
				logoutNow()
				return
			}
			this.setState({
				waitForResumeTimer: _waitTimer-1
			})
			// this.waitForResumeTimer++
		}, 1000)
	}

	resumeTest = () => {
		clearInterval(this.waitForResumeInterval)
		window.stopOverallTimer = false
		this.setState((prevState) => {
			return {
					...prevState,
				isIdleTimeup: false,
			};
		});
		
		console.log('this.state ', this.state)

		// this.waitForResumeTimer = 0
		this.setState({
			waitForResumeTimer: 10
		})
		this.idleInstance.resume();
		this.updatePauseTime('updateNow')
		this.startIsTimeUpInterval()
		// window.location.reload()
		// this.startIdleInterval()
	}

	updatePauseTime = (type) => {
		let attempt_id = this.props.currentAttemptId;
		let pause_time = 0;

		if (!!$('.minuteLeft').text() && !!$('.secondsLeft').text()) {
			pause_time = $('.minuteLeft').text() * 60 + +$('.secondsLeft').text();
		}

		const postData = new FormData()
		postData.append('attempt_id', attempt_id)
		postData.append('pause_time', pause_time)

		// console.log('postData ', postData, ' - ', attempt_id,' - ', pause_time)

		if(type === 'updateIfZero' && pause_time <= 0) {
			this.props.sendPauseTime(postData)
			clearInterval(this.isTimeUp)
		} else if(type === 'updateNow') {
			this.props.sendPauseTime(postData)
		}
		
	}

	startIsTimeUpInterval = () => {
		this.isTimeUp = setInterval(() => {
			this.updatePauseTime('updateIfZero')
		}, 1000 * 1)
	}

	// startIdleInterval = () => {
	// 	clearInterval(this.idleInterval)
	// 	this.idleInterval = setInterval(() => {
	// 		this.onIdle()
	// 	}, 1000 * 60 * 5)
	// }

	render() {
		const {
			isFeedback,
			disableSubmit,
			submitButton,
			leftSectionProps: { qtype = null },
			questionId,
			userType,
		} = this.props;

		// if(qtype === null) {
		// 	window.location.href = localStorage.getItem('uap_callback')
		// }

		return (
			<div>
				{userType === UserTypes.Parent || userType === UserTypes.Junior ? (
					<KidsThankYouModal />
				) : (
					<ThankYouModal />
				)}

				<Modal
					show={this.state.proctorStatus === 'paused' ? true : false}
					size="lg"
					dialogClassName="modal-90w"
					backdrop={true}
					keyboard={false}
					id="proctor-warning-popup"
				>
					<Modal.Body size="lg">
						<div className="warning-box-flex">
							<div className='warning-icon'><i className="fa fa-exclamation-triangle" aria-hidden="true"></i></div>
							<div>
								<strong className='warning-icon-text'>Warning</strong>
								<p className='para-no-outline'>Please restart the test.</p>
								<a className='btn btn-dark mar-top-8' href='/mycourse'>Continue</a>
							</div>
						</div>
					</Modal.Body>
				</Modal>

				<Modal 
					size="lg"
					show={this.state.isIdleTimeup} 
					animation={false}>
					<Modal.Header
						className='pad-bot-0'>
						<Modal.Title
							className='idleModel-head'><div class="exclamation-lg"><i>!</i></div>Are you still there?</Modal.Title>
					</Modal.Header>
					<Modal.Body
						className='idleModel-body pad-bot-0'>You have been idle for a while. Please click 'Continue' to resume the test.</Modal.Body>
					<Modal.Footer
						className='flex-end bord-top-width-0 pad-bot-3m just-cont-center'>
						<Button variant="primary" onClick={this.resumeTest}>Continue ({this.state.waitForResumeTimer})</Button>
					</Modal.Footer>
				</Modal>

				<TestHeader />
				{!!qtype && qtype?.toLowerCase() === 'ins' ? (
					<span>
						<section className="container quiz-page">
							<section className="quiz-page-content">
								<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 test-pg-container  nopadding">
									<InsQuestion />
								</div>
							</section>
						</section>

						<section className="quiz-page-footer">
							<button
								aria-label="Submit Answer"
								onClick={this.submitFunction}
								className={` btn btn-lg btn-info go-next `}
								data-toggle="tooltip"
								data-placement="top"
								id="testSubmit"
								title="Submit Answer"
							>
								Next
							</button>
						</section>
					</span>
				) : (
					<span>
						{!isFeedback ? (
							<span>
								<span className="container quiz-page">
									<ListAnimation className="quiz-page-content">
										<Question />
									</ListAnimation>
								</span>
								<section className="quiz-page-footer">
									<button
										aria-label="Submit"
										onClick={this.submitFunction}
										key={questionId}
										className={` ${
											disableSubmit ? 'disabledElement' : ''
										} btn btn-lg btn-info go-next" `}
										data-toggle="tooltip"
										data-placement="top"
										id="testSubmit"
										title="Submit Answer"
										ref={this.submitBtnRef2}
									>
										{submitButton}
									</button>
								</section>
							</span>
						) : (
							<span>
								<section className="container quiz-page">
									<ListAnimation className="quiz-page-content">
										<QuestionFeedback />
									</ListAnimation>
								</section>
								<section className="quiz-page-footer">
									<button
										aria-label="Next question"
										onClick={this.submitFunction}
										className={` ${
											disableSubmit ? 'disabledElement' : ''
										} btn btn-lg btn-info go-next" `}
										data-toggle="tooltip"
										key={questionId}
										data-placement="top"
										id="testSubmit"
										title="Next question"
										ref={this.submitBtnRef}
									>
										{submitButton}
									</button>
								</section>
							</span>
						)}
					</span>
				)}

				<HelpModal />
			</div>
		);
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(TestPage);
